import { inject } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { ErrorLink } from '@apollo/client/link/error';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
import * as Sentry from '@sentry/angular';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

export function provideApolloClient(config: { kobitoUri: string }) {
  return [
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      const errorLink = new ErrorLink(({ error }) => {
        if (CombinedGraphQLErrors.is(error)) {
          Sentry.captureException(error);
        }
      });

      const link = ApolloLink.from([
        errorLink,
        httpLink.create({
          uri: config.kobitoUri,
          // https://the-guild.dev/graphql/apollo-angular/docs/data/network#file-upload
          extractFiles: (body) => extractFiles(body, isExtractableFile),
        }),
      ]);

      return {
        cache: new InMemoryCache(),
        link,
      };
    }),
  ];
}
